import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { Workgroup } from '../../../models/workgroup'
import { ClientMessage } from '../../../models/clientMessage'
import { DomSanitizer } from '@angular/platform-browser'
import { IonicModule, AlertController, IonInfiniteScroll } from '@ionic/angular'
import { first } from 'rxjs/operators'
import { SortByPipe } from '../../../shared/pipes/sort-by.pipe'
import { BypassHtmlSanitizerPipe } from '../../../shared/pipes/bypass-html-sanitizer.pipe'
import { NestedEllipsisModule } from 'ngx-nested-ellipsis'

@Component({
  selector: 'app-client-messages-history-list',
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    DatePipe,
    SortByPipe,
    BypassHtmlSanitizerPipe,
    NestedEllipsisModule,
  ],
  templateUrl: './client-messages-history-list.component.html',
  styleUrls: ['./client-messages-history-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientMessagesHistoryListComponent implements OnInit, OnChanges {
  sanitizer = inject(DomSanitizer)
  private alertCtrl = inject(AlertController)

  @Input() messages: ClientMessage[]
  @Input() workgroups: Workgroup[]

  @Output() loadClientOutboundMessagesFromOffset = new EventEmitter<number>()

  @ViewChild('infiniteScroll') infiniteScroll: IonInfiniteScroll

  ngOnInit() {
    this.loadMoreData()
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes)
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'messages':
            if (!this.messages) break
            this.infiniteScroll.complete()
            break
        }
      }
    }
  }

  async openMessage(msg: ClientMessage) {
    const recipient = msg.recipient?.fullName() || 'Adresát nenalezen'

    const fromAndContent = `Komu: ${recipient}<br>${msg.content}`

    const alert = await this.alertCtrl.create({
      cssClass: 'clientHistoryMessageAlert',
      header: recipient,
      message: fromAndContent,
      buttons: [
        {
          text: 'Zpět',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Zpět', blah)
          },
        },
      ],
    })

    await alert.present()
  }

  loadMoreData() {
    console.log('loading more sms...')
    this.loadClientOutboundMessagesFromOffset.emit(this.messages?.length || 0)
  }
}
